<template>
    <div class="data-nomore">
      - 没有更多了 -
    </div>
</template>

<script>

export default {
  name: 'Nomore',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.data-nomore{
    width: 100%;
    padding: 0.1rem 0 0.2rem;
    font-size: 0.12rem;
    color: #999999;
}
</style>
